import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import Table from "../../Common/Table";
import TableFields from "../../../constants/Disputes/TableFields.json";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DisputesActions from "../../../store/actions/Disputes";

const DisputesListTable = ({ list = [], resetDisputesDetails }) => {
    const history = useHistory();
    const getFieldValue = (item, key) => {
        switch (key) {
            case "id":
                return (
                    <span
                        onClick={(event) => handleRowClick(item, event)}
                        className="edit-options"
                    >
                        {item.id}
                    </span>
                );
            default:
                return item[key];
        }
    };

    const handleRowClick = (item, event) => {
        if (event.metaKey) {
            // Open in a new tab
            event.preventDefault(); // Prevents the default navigation behavior
            const url = `/disputes/${item.id}`;
            window.open(window.location.origin + url, "_blank");
        } else {
            // Navigate in the current tab
            history.push(`/disputes/${item.id}`);
        }
    };

    return (
        <PartnersListTableContainer>
            {list.length > 0 ? (
                <Table
                    fontSize="0.75rem"
                    list={list}
                    fields={TableFields}
                    getFieldValue={getFieldValue}
                />
            ) : (
                <div />
            )}
        </PartnersListTableContainer>
    );
};

const PartnersListTableContainer = styled.div`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
`;

function mapDispatchToProps(dispatch) {
    return {
        resetDisputesDetails: bindActionCreators(
            DisputesActions.resetDisputesDetails,
            dispatch
        ),
    };
}

export default connect(null, mapDispatchToProps)(DisputesListTable);
